/**
 * Feature flags convention: go/frontend-feature-flags
 */

import { ff } from '@atlassian/jira-feature-flagging';

export const isDisableDevopsFeaturesInFedRampEnvEnabled = () =>
	ff('core-x-fedramp-m1-disable-devops-features_ag5zy');
